import React, { useState } from 'react';

import useDeviceTypeDetector from '../../hooks/useDeviceTypeDetector';
import googlePlayIcon from '../../assets/icon/Google-play.svg';
import appStoreIcon from '../../assets/icon/App-store.svg';
import ruStoreIcon from '../../assets/icon/RuStore.svg';
import ruStoreQr from '../../assets/brand/rustore_qr.png';
import appleStoreQr from '../../assets/brand/apple_qr.png';
import playStoreQr from '../../assets/brand/playstore_qr.png';
import logoTransparent from '../../assets/svg/logo-transparent.svg';
import brandLogo from '../../assets/svg/brand-logo.svg';
import tgLogo from '../../assets/icon/Telegram.svg';
import emailLogo from '../../assets/icon/email.svg';
import DeleteAccountModal from '../../components/DeleteAccountModal/DeleteAccountModal'; // Adjust the path as needed

import { sectionIds } from '../../utils/constants';

import './Download.scss';

const gadgetsData = [
  {
    qr: appleStoreQr,
    icon: appStoreIcon,
    title: 'App Store',
    className: 'app-store',
  },
  {
    qr: playStoreQr,
    icon: googlePlayIcon,
    title: 'Google Play',
    className: 'google-play',
  },
  {
    qr: ruStoreQr,
    icon: ruStoreIcon,
    title: 'Ru Store',
    className: 'ru-store',
  },
];

const DownloadSection = () => {
  const { isLaptop, isMobile } = useDeviceTypeDetector();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const isSmallScreen = isLaptop || isMobile;

  return (
    <section className="download-section" id={sectionIds.download}>
      <div className="content">
        <div className="gadgets-wrapper">
          <p className="section-title">Скачать JiVA</p>
          <div className="gadget-list">
            {gadgetsData.map((item, i) => {
              return (
                <div className={`gadget ${item.className}`} key={`${i}`}>
                  <div className="info">
                    <img src={item.icon} alt={`${item.title} logo`} />
                    <span>{item.title}</span>
                  </div>
                  {isSmallScreen ? (
                    <button className="install-btn">Установить</button>
                  ) : (
                    <div className="qr-code">
                      <img src={item.qr} alt={`${item.title} qr code`} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="footer-wrapper">
          <img src={logoTransparent} alt="transparent logo" />
          <div className="container footer">
            <div className="socials-wrapper">
              <img src={brandLogo} alt="brand logo" />
              <div className="social-links">
                <a target="_blank" href="https://t.me/jiva_support_bot">
                  <img src={tgLogo} alt="Telegram logo" />
                </a>
                <a href="mailto:support@jivatech.ru" className="email-link">
                  <img
                    src={emailLogo}
                    alt="Email"
                    className="email-link__icon"
                  />
                  <span className="email-link__text">support@jivatech.ru </span>
                </a>
              </div>
            </div>

            <div className="privacy-policy">
              <a href="/privacy-policy" rel="noopener noreferrer">
                Политика конфиденциальности
              </a>
              <a href="/user-policy" rel="noopener noreferrer">
                Пользовательское соглашение
              </a>
              <button
                type="button"
                style={{
                  height: 48,
                  padding: '0 24px',
                  fontFamily: 'var(--font-open-sans)',
                  fontWeight: 600,
                  fontSize: 16,
                  lineHeight: '48px',
                  borderRadius: 32,
                  color: 'var(--color-btn-primary)',
                  backgroundColor: 'var(--color-btn-secondary-default)',
                  border: 'none',
                  cursor: 'pointer'
                }}
                onClick={() => setDeleteModalOpen(true)}
              >
                Удалить аккаунт
              </button>
            </div>
          </div>
        </div>
      </div>
      <DeleteAccountModal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} />

    </section>
  );
};

export default DownloadSection;
